import { render, staticRenderFns } from "./classroomInfo1.vue?vue&type=template&id=69d49fe2&scoped=true"
import script from "./classroomInfo1.vue?vue&type=script&lang=js"
export * from "./classroomInfo1.vue?vue&type=script&lang=js"
import style0 from "./classroomInfo1.vue?vue&type=style&index=0&id=69d49fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d49fe2",
  null
  
)

export default component.exports